import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, DollarSign, CheckCircle2, ArrowRight } from 'lucide-react';
const creditFeatures = ['Revision de reporte de credito', 'Estrategia de disputa personalizada', 'Plan de mejora de puntuacion y asesoramiento', 'Monitoreo continuo de credito y actualizacion'];
const fundingFeatures = ['Business Lines of Credit', 'Personal Lines of Credit', 'Personal Loans', 'Credit Card Stacking & more'];
export function Services() {
  return <section id="servicios" className="bg-black py-32 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-223" data-mp="z4wcqn1y7hx2">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(245,158,11,0.05),transparent_50%)] pointer-events-none" data-id="element-224" data-mp="u6ux6c3qe0qc" />

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-225" data-mp="q2n6489sw8oy">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 1,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-center mb-20" data-id="element-226" data-mp="l424q5itbiyx">
          <span className="inline-block text-xs font-semibold tracking-[0.3em] uppercase bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent mb-6" data-id="element-227" data-mp="2xdcnn7seg0q5">
            Nuestros Servicios
          </span>
          <h2 className="text-4xl md:text-6xl font-bold text-white tracking-tight mb-6 leading-[1.1]" data-id="element-228" data-mp="3pycg66fj27q1">
            Dos Pilares,{' '}
            <span className="italic font-black bg-gradient-to-b from-amber-200 via-amber-400 to-amber-600 bg-clip-text text-transparent" data-id="element-229" data-mp="3g2sndsw9fp5i">
              Un Solo Objetivo
            </span>
          </h2>
          <p className="text-lg md:text-xl text-white/50 font-light max-w-2xl mx-auto" data-id="element-230" data-mp="24mkukj6mrs71">
            Optimizamos tu credito y conseguimos el capital que necesitas, todo
            con un servicio completamente personalizado.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-231" data-mp="1pm6wfdybuunt">
          {/* Service 01 — Credit */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.8,
          ease: [0.16, 1, 0.3, 1]
        }} className="flex flex-col p-8 md:p-10 rounded-3xl bg-gradient-to-b from-white/[0.04] to-white/[0.01] border border-white/[0.08]" data-id="element-232" data-mp="1lklmo1h3awhu">
            <div className="flex items-center gap-4 mb-8" data-id="element-233" data-mp="sulentral3ar">
              <div className="h-14 w-14 rounded-2xl bg-gradient-to-b from-amber-300/20 to-amber-600/10 border border-amber-500/20 flex items-center justify-center" data-id="element-234" data-mp="sw697jdlwm8m">
                <TrendingUp className="h-7 w-7 text-amber-400" strokeWidth={2} data-id="element-235" data-mp="2n8e10numsn06" />
              </div>
              <span className="text-sm font-semibold tracking-[0.25em] uppercase bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent" data-id="element-236" data-mp="2zq6wchhqdxhl">
                Servicio 01
              </span>
            </div>

            <h3 className="text-3xl md:text-4xl font-bold text-white mb-5" data-id="element-237" data-mp="39f8eoebr0qyq">
              Optimizacion de{' '}
              <span className="italic bg-gradient-to-b from-amber-200 via-amber-400 to-amber-600 bg-clip-text text-transparent" data-id="element-238" data-mp="2btt3c8lkkk9h">
                Credito
              </span>
            </h3>
            <p className="text-white/50 font-light leading-relaxed mb-8" data-id="element-239" data-mp="2lpmj00ul4tvh">
              Revisamos tu reporte de credito y diseñamos una estrategia
              totalmente personalizada para ti, con el objetivo de optimizarlo y
              hacerlo atractivo para los bancos y demas instituciones
              financieras para conseguir capital.
            </p>

            <ul className="space-y-4 mb-10 flex-grow" data-id="element-240" data-mp="3kmmx3cun6t5">
              {creditFeatures.map((feature, i) => <li key={i} className="flex items-center gap-3" data-id="element-241" data-mp="3urpcxrgyb71s" data-mpi={i}>
                  <CheckCircle2 className="h-5 w-5 text-amber-400 shrink-0" strokeWidth={2} data-id="element-242" data-mp="3utk0ldjlxd9k" />
                  <span className="text-white/70 font-light" data-id="element-243" data-mp="8ixvlarerb9s">{feature}</span>
                </li>)}
            </ul>

            <a href="https://calendly.com/vantixcredit/diagnostico-de-credito" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 font-semibold bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent group" data-id="element-244" data-mp="mhxpawts2gct">
              Quiero optimizar mi credito
              <ArrowRight className="h-4 w-4 text-amber-400 group-hover:translate-x-1 transition-transform" data-id="element-245" data-mp="15b1jcjawqv7y" />
            </a>
          </motion.div>

          {/* Service 02 — Funding (highlighted) */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.8,
          delay: 0.15,
          ease: [0.16, 1, 0.3, 1]
        }} className="flex flex-col p-8 md:p-10 rounded-3xl bg-gradient-to-b from-amber-500/[0.06] to-transparent border border-amber-500/30 shadow-2xl shadow-amber-500/5" data-id="element-246" data-mp="1jy8mw3y2cqwt">
            <div className="flex items-center gap-4 mb-8" data-id="element-247" data-mp="s7c82xsg0c6w">
              <div className="h-14 w-14 rounded-2xl bg-gradient-to-b from-amber-300/20 to-amber-600/10 border border-amber-500/30 flex items-center justify-center" data-id="element-248" data-mp="w6us7rcfwj8o">
                <DollarSign className="h-7 w-7 text-amber-400" strokeWidth={2} data-id="element-249" data-mp="i9xsf0ecfrfn" />
              </div>
              <span className="text-sm font-semibold tracking-[0.25em] uppercase bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent" data-id="element-250" data-mp="2owvq1ev1jxyc">
                Servicio 02
              </span>
            </div>

            <h3 className="text-3xl md:text-4xl font-bold text-white mb-5" data-id="element-251" data-mp="2g41zgla59c56">
              Funding{' '}
              <span className="italic bg-gradient-to-b from-amber-200 via-amber-400 to-amber-600 bg-clip-text text-transparent" data-id="element-252" data-mp="2b6a4fie7d9wr">
                Solutions
              </span>
            </h3>
            <p className="text-white/50 font-light leading-relaxed mb-8" data-id="element-253" data-mp="33tmggymqlzbt">
              Luego de optimizar tu reporte de credito, diseñamos estrategias
              personalizadas para conseguir el capital que necesitas para
              emprender o impulsar tu negocio.
            </p>

            {/* Capital range highlight box */}
            <div className="rounded-2xl border border-amber-500/20 bg-black/40 p-6 mb-8" data-id="element-254" data-mp="1ifrtjv78m48s">
              <div className="text-xs font-semibold tracking-[0.2em] uppercase text-white/40 mb-3" data-id="element-255" data-mp="1ii4hcozof8tr">
                Rango de Capital Disponible
              </div>
              <div className="text-3xl md:text-4xl font-bold bg-gradient-to-b from-amber-200 via-amber-400 to-amber-600 bg-clip-text text-transparent" data-id="element-256" data-mp="1dbfvcv6ejnws">
                $50,000 a $100,000
              </div>
            </div>

            <ul className="space-y-4 mb-10 flex-grow" data-id="element-257" data-mp="1n2tz5f5dz9vq">
              {fundingFeatures.map((feature, i) => <li key={i} className="flex items-center gap-3" data-id="element-258" data-mp="1w1fgx831akvg" data-mpi={i}>
                  <CheckCircle2 className="h-5 w-5 text-amber-400 shrink-0" strokeWidth={2} data-id="element-259" data-mp="1vzuphrc0ni1t" />
                  <span className="text-white/70 font-light" data-id="element-260" data-mp="26050r6ehqfec">{feature}</span>
                </li>)}
            </ul>

            <a href="https://calendly.com/vantixcredit/diagnostico-de-credito" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 font-semibold bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent group" data-id="element-261" data-mp="6nssud0gzlx3">
              Quiero acceder a financiamiento
              <ArrowRight className="h-4 w-4 text-amber-400 group-hover:translate-x-1 transition-transform" data-id="element-262" data-mp="2n9fq14574q78" />
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}